export default {

  apiHost: () => process.env.NODE_ENV === 'production'
    ? process.env.API_HOST
    : process.env.API_HOST || 'http://localhost:5000',

  enableYandex: () => process.env.NODE_ENV === 'production'

}



// WEBPACK FOOTER //
// ./src/settings.js